import { CircularProgress } from '@mui/material';
import { FlexDiv } from 'crono-fe-common/components/Layout/FlexDiv';
import { useAccountDrawer } from 'context/accountDrawer';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PATH from 'crono-fe-common/constants/path';
import useGetTaskCall from 'hooks/services/event/useGetTaskCall';

const CallInterceptor = () => {
  const [searchParams] = useSearchParams();
  const accountId = searchParams.get('accountId') ?? undefined;
  const prospectId = searchParams.get('prospectId') ?? undefined;
  const callId = searchParams.get('callId') ?? undefined;
  const { openCallLogDrawer } = useAccountDrawer();
  const { data: taskCall, error } = useGetTaskCall(prospectId, callId, true);

  const navigate = useNavigate();

  useEffect(() => {
    const handleCall = async () => {
      const activity = taskCall?.data?.data;

      if (!activity || !accountId) return;

      openCallLogDrawer({
        accountId,
        prospectId,
        activity,
      });

      navigate(PATH.HOME);
    };
    handleCall();
  }, [taskCall]);

  useEffect(() => {
    if (error) {
      navigate(PATH.HOME);
    }
  }, [error]);

  return (
    <>
      <FlexDiv>
        <CircularProgress />
      </FlexDiv>
    </>
  );
};

export default CallInterceptor;
